import React, { useEffect, useState } from 'react';
import { logout } from "./Utility";
import Tabs, { Tab } from 'react-best-tabs';
import '../assets/css/client-dropout.css';
import customFetch from './apicall/api';
import { generateId } from './Utility';

const ClientDropout = (props) => {
    const [isSpin, setisSpin] = useState(false);
    const [isAndroid, setisAndroid] = useState(false);
    const [isDropoutChecked, setIsDropoutChecked] = useState({});
    const [dropoutReason, setDropoutReason] = useState({});
    const [remark, setRemark] = useState({});
    const [searchQuery, setSearchQuery] = useState('');
    const [searchQuerydropout, setsearchQuerydropout] = useState('');
    const [reasonList, setreasonList] = useState();
    const [clientDetail, setclientDetail] = useState();
    const [clientdropoutDetail, setclientdropoutDetail] = useState();
    const [location, setLocation] = useState({ latitude: null, longitude: null, address: null });
    const [error, setError] = useState(null);
    const [ipaddress, setipaddress] = useState();
    const [profilePhotos, setProfilePhotos] = useState({});
    const [profilePhotosDropout, setProfilePhotosDropout] = useState({});

    const generate_Id1 = generateId(10);

    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLocation({
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                    });
                    getAddress(position.coords.latitude, position.coords.longitude);
                },
                (error) => {
                    setError(error.message);
                }
            );
        } else {
            setError('Geolocation is not supported by this browser.');
        }

        fetch("https://geolocation-db.com/json/")
            .then((response) => {
                return response.json();
            }, "jsonp")
            .then((res) => {
                console.log(res);
                setipaddress(res.IPv4);
            })
            .catch((err) => console.log(err));
    }, []);

    const getAddress = async (latitude, longitude) => {
        try {
            const response = await fetch(
                `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`
            );
            const data = await response.json();
            if (data.error) {
                setError("Error fetching address: " + data.error);
            } else {
                setLocation(prevState => ({ ...prevState, address: data.display_name }));
            }
        } catch (error) {
            setError("Error fetching address: " + error.message);
        }
    };
    useEffect(() => {
        if (
            window.Android &&
            typeof window.Android.getDataFromLocalStorage === "function"
        ) {
            setisAndroid(true);
            const data = window.Android.getDataFromLocalStorage("your_key");
            if (data) {
                setisAndroid(false);
                const tokenParts = data.split(",");
                const tokenData = {};

                tokenParts.forEach((part) => {
                    const [key, value] = part.split(":");
                    tokenData[key] = value;
                });
                localStorage.setItem("api_token", tokenData.access_token);
            }
        } else {
            console.log(
                "Error in AndroidInterface: Android method not found or not available."
            );
        }
    }, []);
    useEffect(() => {
        const requestOptions = {
            method: "GET",
            headers: {
                "api-token": localStorage.getItem("api_token"),
            },
        };
        customFetch(
            process.env.REACT_APP_URL +
            "/get/master/data?table_name=hold_dropout_reason_master&reason_flag=D&flag=1",
            requestOptions
        )
            .then((response) => {
                return response.json();
            }).then((data) => {
                console.log('data', data)
                setreasonList(data.data);
            })
    }, []);
    useEffect(() => {
        const fetchPhotos = async () => {
            const newPhotos = {};
            for (const client of clientDetail.household_data) {
                const path = 'navadhanftp/' + process.env.REACT_APP_ENVIRONMENT + '/' + client.profile_photo_filename; // or wherever it comes from
                // const path = "cheque_collection_by_cso/dev/2024/12/376_Capture.JPG"; // or wherever it comes from
                const generate_Id = generateId(10);
                const requestOptions = {
                    method: "POST",
                    headers: {
                        "api-token": localStorage.getItem("api_token"),
                        component_id: generate_Id1,
                        apiId: generate_Id,
                        component: "Esign",
                        user_id: localStorage.getItem("in_userid"),
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ source_blob_name: path, client_id: 'Collection UI' }),
                };
                try {
                    const res = await customFetch(process.env.REACT_APP_FILE_DOWNLOAD + "/gcs/download", requestOptions);
                    const img = await res.blob();
                    console.log('Image Blob:', img.size, img.type);
                    if(img.type !== 'image/jpeg' && img.type !== 'image/png') {
                        newPhotos[client.household_number] = require("../assets/images/pp.png"); // Fallback image if not a valid image type
                    } else {
                        newPhotos[client.household_number] = URL.createObjectURL(img);
                    }
                    console.log(newPhotos);
                } catch (e) {
                    console.error("Error loading image for", client.household_number);
                }
            }
            setProfilePhotos(newPhotos);
        };
    
        if (clientDetail) fetchPhotos();
    }, [clientDetail]);
    useEffect(() => {
        const fetchPhotos = async () => {
            const newPhotos = {};
            if (!clientdropoutDetail || !clientdropoutDetail.household_data || !Array.isArray(clientdropoutDetail.household_data)) {
                setProfilePhotosDropout(newPhotos);
                return;
            }

            for (const client of clientdropoutDetail.household_data) {
                if (!client.profile_photo_filename) {
                    newPhotos[client.household_number] = require("../assets/images/pp.png");
                    continue;
                }

                const path = 'navadhanftp/' + process.env.REACT_APP_ENVIRONMENT + '/' + client.profile_photo_filename;
                const generate_Id = generateId(10);
                const requestOptions = {
                    method: "POST",
                    headers: {
                        "api-token": localStorage.getItem("api_token"),
                        component_id: generate_Id1,
                        apiId: generate_Id,
                        component: "Esign",
                        user_id: localStorage.getItem("in_userid"),
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ source_blob_name: path, client_id: 'Collection UI' }),
                };
                try {
                    const res = await customFetch(process.env.REACT_APP_FILE_DOWNLOAD + "/gcs/download", requestOptions);
                    if (!res.ok) {
                        throw new Error('Failed to fetch image');
                    }
                    const img = await res.blob();
                    if(img.type !== 'image/jpeg' && img.type !== 'image/png') {
                        newPhotos[client.household_number] = require("../assets/images/pp.png");
                    } else {
                        newPhotos[client.household_number] = URL.createObjectURL(img);
                    }
                } catch (e) {
                    console.error("Error loading image for", client.household_number, e);
                    newPhotos[client.household_number] = require("../assets/images/pp.png");
                }
            }
            setProfilePhotosDropout(newPhotos);
        };
        if (clientdropoutDetail) fetchPhotos();
    }, [clientdropoutDetail]);
    const handleSave = (loan_documentation_id, household_number) => {
        setisSpin(true);
        if (!dropoutReason[household_number]) {
            alert('Please select a reason for client dropout');
            setisSpin(false);
            return;
        }
        if (!remark[household_number]) {
            alert('Please enter remark for client dropout');
            setisSpin(false);
            return;
        }
        const inputFields = {
            loan_documentation_id: parseInt(loan_documentation_id),
            dropout_reason_id: parseInt(dropoutReason[household_number]),
            dropout_remark: remark[household_number],
            latitude: String(location.latitude),
            longitude: String(location.longitude),
            gps_address: location.address,
            userid: parseInt(localStorage.getItem("in_userid")),
            client_ip: ipaddress,
        };
        const _body = JSON.stringify(inputFields);
        const requestOptions = {
            method: "POST",
            headers: {
                "api-token": localStorage.getItem("api_token"),
                "Content-Type": "application/json"
            },
            body: _body,
        };

        customFetch(
            process.env.REACT_APP_URL + "/register_customer_dropout",
            requestOptions
        )
            .then((res) => {
                return res.json();
            })
            .then((response) => {
                // this.setState({
                //     isErrOpen: true,
                //     apiErrorMessage: response.message,
                // });
                alert(response.message);
                setRemark(prev => ({ ...prev, [household_number]: "" }));;
                setDropoutReason(prev => ({ ...prev, [household_number]: "" }));
                setIsDropoutChecked(prev => ({ ...prev, [household_number]: false }));
                setisSpin(false);
                searchclient();
            });
        // Here you would typically send the data to a server
        console.log('Saving dropout data:', { dropoutReason, remark });
    };

    const searchclient = () => {
        setisSpin(true);
        const requestOptions = {
            method: "GET",
            headers: {
                "api-token": localStorage.getItem("api_token"),
            },
        };
        setclientDetail(null);
        let url = `fetch/qcdone/customers?exact_match=true&household_number=${searchQuery || ''}`;

        customFetch(
            process.env.REACT_APP_URL + "/" + url,
            requestOptions
        )
        .then((response) => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        }).then((data) => {
            console.log('Filtered data', data);
            setisSpin(false);
            if (searchQuery && searchQuery !== "") {
                const filteredData = {
                    ...data,
                    household_data: data.household_data.filter(
                        client => client.household_number === searchQuery
                    )
                };
                setclientDetail(filteredData);
            } else {
                setclientDetail(data);
            }
        }).catch((err) => {console.error('Search error:', err);setisSpin(false);});
    }
    const searchclientdropout = () => {
        setisSpin(true);
        const requestOptions = {
            method: "GET",
            headers: {
                "api-token": localStorage.getItem("api_token"),
            },
        };
        setclientdropoutDetail(null);
        let url = `fetch/dropout/customers?exact_match=true&household_number=${searchQuerydropout || ''}`;
        customFetch(
            process.env.REACT_APP_URL + "/" + url,
            requestOptions
        )
        .then((response) => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        })
        .then((data) => {
            console.log('Filtered dropout data', data);
            setisSpin(false);
            
            if (!data || !data.household_data) {
                setclientdropoutDetail({ household_data: [] });
                return;
            }
            if (searchQuerydropout && searchQuerydropout !== "") {
                const filteredData = {
                    ...data,
                    household_data: data.household_data.filter(
                        client => client.household_number === searchQuerydropout
                    )
                };
                setclientdropoutDetail(filteredData);
            } else {
                setclientdropoutDetail(data);
            }
        })
        .catch((err) => {console.error('Dropout search error:', err);setisSpin(false);
            setclientdropoutDetail({ household_data: [] });
        });
    }
    return (
        <>
            {isSpin ? (
                <div className="preloader">
                    <div className="loader" ng-hide="data.length > 0"></div>
                </div>
            ) : (
                ""
            )}
            <section className="main-sec">
                <div className="container fix-width">
                    <div className="header-area">
                        <div
                            className="icon_bg"
                            onClick={() => props.history.goBack()}
                        >
                            <img
                                src={require("../assets/images/back.png")}
                                className="cso_icon_img"
                                alt=""
                            />
                        </div>
                        <div className="head-title">Client dropout</div>
                        {isAndroid ? (
                            <></>
                        ) : (
                            <div className="log-out-report">
                                <img
                                    src={require("../assets/images/power-off.png")}
                                    onClick={() => logout()}
                                    alt=""
                                />
                            </div>
                        )}
                    </div>
                    <div className="tabs-container">
                        <Tabs
                            activeTab="1"
                            className="client-tabs"
                            ulClassName="tab-list"
                            activityClassName="active-tab"
                        >
                            <Tab title="All cases" className="tab-item">
                                <div className="search-filters">
                                    <div className="search-container">
                                        <input
                                            type="text"
                                            placeholder="HH ID - MP001LE000052"
                                            className="search-input"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                        <button className="search-button" onClick={() => searchclient()}>
                                            Search
                                            <i className="fa fa-search"></i>
                                        </button>
                                    </div>
                                    {/* <div className="filters-container">
                                        <div className="filter">
                                            <button className="filter-button">
                                                Date
                                                <i className="fa fa-calendar"></i>
                                            </button>
                                        </div>
                                        <div className="filter">
                                            <button className="filter-button">
                                                Status
                                                <i className="fa fa-filter"></i>
                                            </button>
                                        </div>
                                        <div className="filter">
                                            <button className="filter-button">
                                                Filter
                                                <i className="fa fa-sliders-h"></i>
                                            </button>
                                        </div>
                                    </div> */}
                                </div>

                                {clientDetail && clientDetail.household_data.map((client) => 
                                    <div className="client-card" key={client.household_number}>
                                        <div className="client-info">
                                            <div className="client-avatar">
                                                <img src={profilePhotos[client.household_number] || require("../assets/images/pp.png")} alt="Client Avatar" />
                                            </div>
                                            <div className="client-details">
                                                <h3 className="client-name">{client.household_name}</h3>
                                                <div className="client-id">HH ID - {client.household_number}</div>
                                            </div>
                                            {/* <div className="client-contact">
                                            <div className="phone-number">
                                                <i className="fa fa-phone"></i>
                                                +91- 8286923401
                                            </div>
                                        </div>
                                        <div className="client-address">
                                            <i className="fa fa-map-marker-alt"></i>
                                            803, Ecostar Building, off Aarey Road, Churi Wadi, Goregaon, Mumbai, Maharashtra 400063
                                        </div>
                                        <div className="client-actions">
                                            <button className="more-actions">
                                                <i className="fa fa-ellipsis-v"></i>
                                            </button>
                                        </div> */}
                                        </div>
                                        <hr style={{ marginTop: 0, marginBottom: 0 }} />
                                        <div className=''>
                                            <div className='rotated loan-tag' style={{ float: 'left' }}>Loan details</div>
                                            <div className="client-details-grid row">
                                                <div className="detail-item col-md-3">
                                                    <div className="detail-label">Partner</div>
                                                    <div className='position-absolute left-15'>
                                                        <span className="ml-1 fw-medium">{client.partner_code}</span>
                                                    </div>
                                                </div>
                                                <div className="detail-item col-md-4">
                                                    <div className="detail-label">Product</div>
                                                    <div className='position-absolute left-15'>
                                                        <span className="ml-1 fw-medium">{client.product_name}</span>
                                                    </div>
                                                </div>
                                                <div className="detail-item col-md-4">
                                                    <div className="detail-label">Status</div>
                                                    <div className='position-absolute left-15'>
                                                        <span className="ml-1 fw-medium client-sts">{client.status}</span>
                                                        <span className="detail-value fw-medium date-value ml-1">On {client.qc_done_date}</span>
                                                    </div>
                                                </div>
                                                <div className="detail-item col-md-3">
                                                    <div className="detail-label">Amount</div>
                                                    <div className='position-absolute left-15'>
                                                        <span className="ml-1 fw-medium">{client.amount_proposed_now && (client.amount_proposed_now).toLocaleString("en-IN")}/-</span>
                                                    </div>
                                                </div>
                                                <div className="detail-item col-md-4">
                                                    <div className="detail-label">ROI</div>
                                                    <div className='position-absolute left-15'>
                                                        <span className="ml-1 fw-medium">{client.rate_of_interest}%</span>
                                                    </div>
                                                </div>
                                                <div className="detail-item col-md-4">
                                                    <div className="detail-label">Tenor</div>
                                                    <div className='position-absolute left-15'>
                                                        <span className="ml-1 fw-medium">{client.tenure_proposed_now}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="dropout-form row" style={{ clear: 'both' }}>
                                            <div className="form-header">
                                                <div className="checkbox-container baseline">
                                                    <label htmlFor={`markDropout-${client.household_number}`}>Mark client dropout</label>
                                                    <input
                                                        type="checkbox"
                                                        id={`markDropout-${client.household_number}`}
                                                        checked={!!isDropoutChecked[client.household_number]}
                                                        onChange={() =>
                                                            setIsDropoutChecked(prev => ({
                                                                ...prev,
                                                                [client.household_number]: !prev[client.household_number]
                                                            }))
                                                        }
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group d-flex flex-row baseline">
                                                <label style={{ color: 'black', fontWeight: '600' }}>Select reason for client dropout:</label>
                                                <select
                                                    value={dropoutReason[client.household_number] || ""}
                                                    disabled={!isDropoutChecked[client.household_number]}
                                                    className="form-control"
                                                    onChange={(e) =>
                                                        setDropoutReason(prev => ({
                                                            ...prev,
                                                            [client.household_number]: e.target.value
                                                        }))
                                                    }
                                                    style={{ width: '300px', height: '40px', fontSize: '14px' }}
                                                >
                                                    <option value="" disabled>Select</option>
                                                    {reasonList && reasonList.map((reason) =>
                                                        <option value={reason.id}>{reason.reason_description}</option>)
                                                    }
                                                </select>
                                            </div>
                                            <div className="form-group d-flex flex-row baseline">
                                                <label style={{ color: 'black', fontWeight: '600' }}>Remark:</label>
                                                <textarea
                                                    placeholder="Add your remark..."
                                                    disabled={!isDropoutChecked[client.household_number]}
                                                    value={remark[client.household_number] || ""}
                                                    onChange={(e) =>
                                                        setRemark(prev => ({
                                                            ...prev,
                                                            [client.household_number]: e.target.value
                                                        }))
                                                    }
                                                    style={{ width: '300px', height: '60px' }}
                                                ></textarea>
                                            </div>
                                        </div>
                                        <div className="form-footer">
                                            <button 
                                                className="save-button" 
                                                disabled={!isDropoutChecked[client.household_number]}
                                                onClick={() => handleSave(client.loan_documentation_id, client.household_number)}>Save</button>
                                        </div>
                                    </div>
                                )}
                            </Tab>
                            <Tab title="Client dropout cases" className="tab-item">
                                {/* Content for the second tab */}
                                <div className="search-filters">
                                    <div className="search-container">
                                        <input
                                            type="text"
                                            placeholder="HH ID - MP001LE000052"
                                            className="search-input"
                                            value={searchQuerydropout}
                                            onChange={(e) => setsearchQuerydropout(e.target.value)}
                                        />
                                        <button className="search-button" onClick={() => searchclientdropout()}>
                                            Search
                                            <i className="fa fa-search"></i>
                                        </button>
                                    </div>
                                    {/* <div className="filters-container">
                                        <div className="filter">
                                            <button className="filter-button">
                                                Date
                                                <i className="fa fa-calendar"></i>
                                            </button>
                                        </div>
                                        <div className="filter">
                                            <button className="filter-button">
                                                Status
                                                <i className="fa fa-filter"></i>
                                            </button>
                                        </div>
                                        <div className="filter">
                                            <button className="filter-button">
                                                Filter
                                                <i className="fa fa-sliders-h"></i>
                                            </button>
                                        </div>
                                    </div> */}
                                </div>

                                {clientdropoutDetail && clientdropoutDetail.household_data.map((client) => (
                                    <div className="client-card" key={client.household_number}>
                                        <div className="client-info">
                                            <div className="client-avatar">
                                                <img src={profilePhotosDropout[client.household_number] || require("../assets/images/pp.png")} alt="Client Avatar" />
                                            </div>
                                            <div className="client-details">
                                                <h3 className="client-name">{client.household_name}</h3>
                                                <div className="client-id">HH ID - {client.household_number}</div>
                                            </div>
                                            {/* <div className="client-contact">
                                            <div className="phone-number">
                                                <i className="fa fa-phone"></i>
                                                +91- 8286923401
                                            </div>
                                        </div>
                                        <div className="client-address">
                                            <i className="fa fa-map-marker-alt"></i>
                                            803, Ecostar Building, off Aarey Road, Churi Wadi, Goregaon, Mumbai, Maharashtra 400063
                                        </div>
                                        <div className="client-actions">
                                            <button className="more-actions">
                                                <i className="fa fa-ellipsis-v"></i>
                                            </button>
                                        </div> */}
                                        </div>
                                        <hr style={{ marginTop: 0, marginBottom: 0 }} />
                                        <div>
                                            <div className='rotated loan-tag' style={{ float: 'left' }}>Loan details</div>
                                            <div className="client-details-grid row">
                                                <div className="detail-item col-md-4">
                                                    <div className="detail-label">Partner</div>
                                                    <div className='position-absolute left-15'>
                                                        <span className="ml-1 fw-medium">{client.partner_code}</span>
                                                    </div>
                                                </div>
                                                <div className="detail-item col-md-4">
                                                    <div className="detail-label">Product</div>
                                                    <div className='position-absolute left-15'>
                                                        <span className="ml-1 fw-medium">{client.product_name}</span>
                                                    </div>
                                                </div>
                                                <div className="detail-item col-md-4">
                                                    <div className="detail-label">Status</div>
                                                    <div className='position-absolute left-15'>
                                                        <span className="ml-1 fw-medium client-dng">{client.status || 'Client dropout'}</span>
                                                        <span className="detail-value date-value ml-1 fw-medium">On {client.added_at}</span>
                                                    </div>
                                                </div>
                                                <div className="detail-item col-md-4">
                                                    <div className="detail-label">Amount</div>
                                                    <div className='position-absolute left-15'>
                                                        <span className="ml-1 fw-medium">{client.amount_proposed_now && (client.amount_proposed_now).toLocaleString("en-IN")}/-</span>
                                                    </div>
                                                </div>
                                                <div className="detail-item col-md-4">
                                                    <div className="detail-label">ROI</div>
                                                    <div className='position-absolute left-15'>
                                                        <span className="ml-1 fw-medium">{client.rate_of_interest}%</span>
                                                    </div>
                                                </div>
                                                <div className="detail-item col-md-4">
                                                    <div className="detail-label">Tenor</div>
                                                    <div className='position-absolute left-15'>
                                                        <span className="ml-1 fw-medium">{client.tenure_proposed_now}</span>
                                                    </div>
                                                </div>
                                                {/* New row for Last Status */}
                                                <div className="detail-item col-md-12">
                                                    <div className="detail-label">Last Status</div>
                                                    <div className='position-absolute left-15'>
                                                        <span className="ml-1 fw-medium">{client.t_second_last_status}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="dropout-form row" style={{ clear : 'both' }}>
                                            <div className="detail-item col-md-4">
                                                <div className="detail-label">Dropout marked by
                                                </div>
                                                <div className='m-auto'>
                                                    <span className="ml-1 fw-medium">{client.dropout_marked_by}</span>
                                                </div>
                                            </div>
                                            <div className="detail-item col-md-4">
                                                <div className="detail-label">Client dropout reason
                                                </div>
                                                <div className='m-auto'>
                                                    <span className="ml-1 fw-medium">{client.reason}</span>
                                                </div>
                                            </div>
                                            <div className="detail-item col-md-4">
                                                <div className="detail-label">Remark
                                                </div>
                                                <div className='m-auto'>
                                                    <span className="ml-1 fw-medium">{client.remark}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ClientDropout;
